module.exports = __webpack_public_path__ + "img/battery-grey.cfe0989c.svg";